// API base URL - use relative path for same domain, or set via env for different domains
const API_BASE = process.env.REACT_APP_API_BASE || '';

// Warm up the serverless function on page load so it's ready when the user submits
fetch(`${API_BASE}/api/signup`, { method: 'OPTIONS' }).catch(() => {});

// Email signup service
export const emailSignupService = {
  async create(email, isWaitlistOnly = false) {
    try {
      const response = await fetch(`${API_BASE}/api/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, isWaitlistOnly }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to sign up');
      }

      return data;
    } catch (error) {
      console.error('Email signup error:', error);
      throw error;
    }
  },

  async exists(email, signupType) {
    // The exists check is now handled by the signup endpoint
    // This method is called before create(), but the API will handle duplicates
    // So we return false to let the API check
    return false;
  }
};

// Feedback service
export const feedbackService = {
  async create(feedbackText, email = null) {
    try {
      const response = await fetch(`${API_BASE}/api/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ feedbackText, email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Failed to submit feedback');
      }

      return data;
    } catch (error) {
      console.error('Feedback submission error:', error);
      throw error;
    }
  }
};
